:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-column{flex-direction:column;}
:root ._z-10{z-index:10;}
:root ._pos-absolute{position:absolute;}
:root ._r-0px{right:0px;}
:root ._t-0px{top:0px;}
:root ._b-0px{bottom:0px;}
:root ._items-center{align-items:center;}
:root ._justify-center{justify-content:center;}
:root ._pe-none{pointer-events:none !important;}